import { render, staticRenderFns } from "./WallMobile.vue?vue&type=template&id=6c3282c8&scoped=true&"
import script from "./WallMobile.vue?vue&type=script&lang=js&"
export * from "./WallMobile.vue?vue&type=script&lang=js&"
import style0 from "./WallMobile.vue?vue&type=style&index=0&id=6c3282c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3282c8",
  null
  
)

export default component.exports